export default __webpack_public_path__ + "assets/customMarkerTDH.png";